import { render } from "./ChartBox.vue?vue&type=template&id=2dc5199e&scoped=true"
import script from "./ChartBox.vue?vue&type=script&lang=js"
export * from "./ChartBox.vue?vue&type=script&lang=js"

import "./ChartBox.vue?vue&type=style&index=0&id=2dc5199e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc5199e"]])

export default __exports__